var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"text"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',{staticClass:"title_1"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"title_2"},[_vm._v(_vm._s(_vm.letter))])]),_vm._v(" "),_c('div',{staticClass:"line"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7746edd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = null
// module chunks = 